/* eslint-disable react/prefer-stateless-function */
/* eslint-disable react/jsx-filename-extension */
import React, { Component } from 'react';

export default class Footer extends Component {
  render() {
    return (
      <footer className="str-footer" id="str-footer">
        <div className="container" id="str-footer">
          <span>&nbsp;</span>
        </div>
      </footer>

    );
  }
}
